import { jsx as _jsx } from "react/jsx-runtime";
import { useConfig } from "../../providers/useConfig";
import { WebPushNotificationsController } from "./WebPushNotificationsController";
export const WebPushNotifications = () => {
    const { isFirebaseEnabled = false } = useConfig();
    if (!isFirebaseEnabled) {
        return null;
    }
    return _jsx(WebPushNotificationsController, {});
};
//# sourceMappingURL=WebPushNotifications.js.map